import axios from 'axios';
import { useToast } from 'vue-toastification';

const toast = useToast();

const toastOptions = {
  position: 'top-right',
  pauseOnHover: false,
  timeout: 4000,
  maxToasts: 10,
  pauseOnFocusLoss: false,
};

function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(^|;\\s*)${name}=([^;]*)`));
  return match ? decodeURIComponent(match[2]) : null;
}

function removeAuthHeader(headers) {
  if (!headers) return;

  if (typeof headers.delete === 'function') {
    headers.delete('Authorization');
  } else {
    delete headers.Authorization;
  }
}

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-store, no-cache, must-revalidate, proxy-revalidate, max-age=0',
    Pragma: 'no-cache',
    Expires: '0',
  },
});

api.interceptors.request.use(config => {
  config.headers = config.headers || {};

  config.headers['X-From-Api'] = '1';
  config.headers['Accept-Language'] = localStorage.getItem('lang') || 'tk';

  const token = localStorage.getItem('token');
  const isAdminChatRequest =
    window.location?.pathname?.startsWith('/adminchat/') &&
    (config.url || '').includes('message_to_admin');

  if (isAdminChatRequest) {
    removeAuthHeader(config.headers);
  } else if (token) {
    config.headers['Authorization'] = `Token ${token}`;
  } else {
    removeAuthHeader(config.headers);
  }

  const csrftoken = getCookie('csrftoken');
  if (csrftoken) {
    config.headers['X-CSRFToken'] = csrftoken;
  }

  if ((config.method || '').toLowerCase() === 'get') {
    config.params = { ...(config.params || {}), _ts: Date.now() };
  }

  if ((config.url || '').includes('message_to_admin')) {
    console.log('[CHAT AUTH]', {
      page: window.location?.pathname,
      url: config.url,
      authorization: config.headers['Authorization'] || null,
      csrf: config.headers['X-CSRFToken'] || null,
      isAdminChatRequest,
    });
  }

  return config;
});

api.interceptors.response.use(
  r => r,
  error => {
    if (error?.config?.skipToast) return Promise.reject(error);

    const status = error?.response?.status || 500;

    if (status === 401) {
      toast.error('401 Unauthorized', toastOptions);
      return Promise.reject(error);
    }

    const msg =
      typeof error?.response?.data === 'string'
        ? error.response.data
        : JSON.stringify(error?.response?.data || {});

    if (status === 404) toast.error('404 Not Found', toastOptions);
    else toast.error(msg, toastOptions);

    return Promise.reject(error);
  },
);

export default api;
